// Project Lightbox — opens gallery + info panel for each project card.
// Richtext content (installed) is cloned from hidden <template> elements (no innerHTML on user data).
(function () {
  var lb = document.querySelector('[data-sva-lightbox]');
  if (!lb) return;

  var imgEl      = lb.querySelector('[data-sva-img]');
  var videoEl    = lb.querySelector('[data-sva-video]');
  var prevBtn    = lb.querySelector('[data-sva-prev]');
  var nextBtn    = lb.querySelector('[data-sva-next]');
  var counter    = lb.querySelector('[data-sva-counter]');
  var thumbsWrap = lb.querySelector('[data-sva-thumbs]');
  var carEl      = lb.querySelector('[data-sva-car]');
  var yearEl     = lb.querySelector('[data-sva-year]');
  var sysRow     = lb.querySelector('[data-sva-system-row]');
  var sysEl      = lb.querySelector('[data-sva-system]');
  var instRow    = lb.querySelector('[data-sva-installed-row]');
  var instEl     = lb.querySelector('[data-sva-installed]');
  var timeWrap   = lb.querySelector('[data-sva-time-wrap]');
  var timeEl     = lb.querySelector('[data-sva-time]');
  var costWrap   = lb.querySelector('[data-sva-cost-wrap]');
  var costEl     = lb.querySelector('[data-sva-cost]');
  var badgeEl    = lb.querySelector('[data-sva-badge]');
  var closeBtns  = lb.querySelectorAll('[data-sva-lightbox-close]');
  var stage      = lb.querySelector('[data-sva-stage]');

  var images = [];
  var index = 0;

  function clearChildren(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function setText(el, txt, parent) {
    if (txt && String(txt).trim()) {
      el.textContent = txt;
      if (parent) parent.hidden = false;
    } else {
      el.textContent = '';
      if (parent) parent.hidden = true;
    }
  }

  // Clone installed content from a hidden <template> by ID — never uses innerHTML on user data.
  function setInstalledFromTemplate(tplId) {
    clearChildren(instEl);
    if (!tplId) { instRow.hidden = true; return; }
    var tpl = document.getElementById(tplId);
    if (!tpl || !tpl.content) { instRow.hidden = true; return; }
    instEl.appendChild(tpl.content.cloneNode(true));
    instRow.hidden = false;
  }

  function isVideo(url) {
    return /\.(mp4|webm|mov)(\?|$)/i.test(url);
  }

  function renderImg(i) {
    if (!images.length) return;
    var src = images[i];
    // Always pause+reset any running video before switching
    if (videoEl) {
      try { videoEl.pause(); } catch (e) {}
      videoEl.removeAttribute('src');
      videoEl.load();
    }
    if (isVideo(src)) {
      imgEl.hidden = true;
      imgEl.removeAttribute('src');
      videoEl.hidden = false;
      // Use poster image while video loads (and as thumbnail in idle state)
      var posterSrc = src.replace(/(\.(mp4|webm|mov))(\?[^"]*)?$/i, '-poster.jpg$3');
      videoEl.poster = posterSrc;
      videoEl.src = src;
      // Browsers require muted for autoplay without user gesture.
      videoEl.muted = true;
      videoEl.autoplay = true;
      videoEl.load();
      // Force play attempt — catch silently if browser blocks (e.g. low-power mode)
      var p = videoEl.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      videoEl.hidden = true;
      imgEl.hidden = false;
      imgEl.classList.add('is-loading');
      imgEl.src = src;
      imgEl.onload = function () { imgEl.classList.remove('is-loading'); };
    }
    counter.textContent = (i + 1) + ' / ' + images.length;
    var thumbs = thumbsWrap.querySelectorAll('.sva-lightbox__thumb');
    thumbs.forEach(function (t, ti) {
      t.classList.toggle('is-active', ti === i);
    });
  }

  function buildThumbs() {
    clearChildren(thumbsWrap);
    if (images.length <= 1) return;
    images.forEach(function (src, i) {
      var wrap = document.createElement('div');
      wrap.className = 'sva-lightbox__thumb-wrap' + (i === 0 ? ' is-active' : '');
      wrap.style.position = 'relative';
      wrap.style.flexShrink = '0';
      wrap.style.cursor = 'pointer';
      var im = document.createElement('img');
      im.className = 'sva-lightbox__thumb' + (i === 0 ? ' is-active' : '');
      if (isVideo(src)) {
        // Look for a poster sibling: replace .mp4/.webm/.mov with -poster.jpg
        var posterSrc = src.replace(/(\.(mp4|webm|mov))(\?[^"]*)?$/i, '-poster.jpg$3');
        im.src = posterSrc;
        im.loading = 'lazy';
        im.style.background = '#000';
        // If poster fails to load, just keep black bg
        im.onerror = function () { im.removeAttribute('src'); };
        // Play icon overlay on top
        var play = document.createElement('div');
        play.textContent = '▶';
        play.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-size:18px;pointer-events:none;text-shadow:0 0 6px rgba(0,0,0,0.7);';
        wrap.appendChild(play);
      } else {
        im.src = src;
        im.loading = 'lazy';
      }
      im.alt = '';
      wrap.insertBefore(im, wrap.firstChild);
      wrap.addEventListener('click', function () { index = i; renderImg(index); });
      thumbsWrap.appendChild(wrap);
    });
  }

  function open(trigger) {
    var gallery = (trigger.getAttribute('data-gallery') || '').split('|').filter(Boolean);
    if (!gallery.length) return;
    images = gallery;
    index = 0;

    setText(carEl, trigger.getAttribute('data-car') || 'Proyecto');
    setText(yearEl, trigger.getAttribute('data-year'), yearEl);
    setText(sysEl, trigger.getAttribute('data-system'), sysRow);
    setInstalledFromTemplate(trigger.getAttribute('data-installed-id'));
    setText(timeEl, trigger.getAttribute('data-time'), timeWrap);
    setText(costEl, trigger.getAttribute('data-cost'), costWrap);
    setText(badgeEl, trigger.getAttribute('data-badge'), badgeEl);

    var multi = images.length > 1;
    prevBtn.hidden = !multi;
    nextBtn.hidden = !multi;
    counter.hidden = !multi;

    buildThumbs();
    renderImg(index);

    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    lb.removeAttribute('inert');
    document.body.classList.add('sva-lb-open');
  }

  function close() {
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    lb.setAttribute('inert', '');
    document.body.classList.remove('sva-lb-open');
    imgEl.removeAttribute('src');
    if (videoEl) {
      try { videoEl.pause(); } catch (e) {}
      videoEl.removeAttribute('src');
      videoEl.load();
    }
  }

  function next() {
    if (!images.length) return;
    index = (index + 1) % images.length;
    renderImg(index);
  }
  function prev() {
    if (!images.length) return;
    index = (index - 1 + images.length) % images.length;
    renderImg(index);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sva-lightbox-trigger]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
    }
  });

  closeBtns.forEach(function (b) { b.addEventListener('click', close); });
  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') next();
    else if (e.key === 'ArrowLeft') prev();
  });

  // Touch swipe
  var touchStartX = 0;
  if (stage) {
    stage.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) { if (dx < 0) next(); else prev(); }
    }, { passive: true });
  }
})();
